// RentaScan — Editorial photography sources (real Unsplash URLs).
// Grouped by usage. Sized/optimized via Unsplash CDN query params.

const U = (id, w = 1600, h) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&q=80&w=${w}${h ? `&h=${h}` : ""}`;

export const PHOTOS = {
  // Restaurateur au travail / cuisine
  chefKitchen:     U("photo-1556909114-f6e7ad7d3136"),
  chefPlating:     U("photo-1607013251379-e6eecfffe234"),
  bistroInterior:  U("photo-1552566626-52f8b828add9"),
  ownerTablet:     U("photo-1600891964092-4316c288032e"),
  bistroWarm:      U("photo-1544148103-0773bf10d330"),

  // Plats servis
  dishTop:         U("photo-1546069901-ba9599a7e63c"),
  dishSide:        U("photo-1567620905732-2d1ec7ab7445"),
  dishPasta:       U("photo-1621996346565-e3dbc353d2e5"),
  dishSteak:       U("photo-1544025162-d76694265947"),
  charcuterie:     U("photo-1544025162-d76694265947"),

  // Factures / paperasse
  invoice:         U("photo-1554224155-6726b3ff858f"),
  papers:          U("photo-1450101499163-c8848c66ca85"),

  // Menus / carte
  menuPaper:       U("photo-1414235077428-338989a2e8c0"),
  handwrittenMenu: U("photo-1555939594-58d7cb561ad1"),

  // Négociation / discussion
  chefTablet:      U("photo-1517248135467-4c7edcad34c4"),
  chefsTalk:       U("photo-1559339352-11d035aa65de"),
};

export default PHOTOS;
